import { useMemo, useState, useEffect } from 'react';

import Background from '../../assets/images/info/Background.jpg';
import BackgroundMobile from '../../assets/images/info/Background-mobile.jpg';
import Logo from '../../assets/images/info/LOGO JASARI@8x.png';
import ToAmXanh from '../../assets/images/info/To am xanh.png';
import AnLanh from '../../assets/images/info/An lanh.png';
import HanhPhuc from '../../assets/images/info/Hanh phuc.png';

import './ProjectInfoPage.scss';

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const ProjectInfoPage = ({ isOpen, onClose }) => {
  const isMobile = useMemo(() => window.innerWidth <= 1024, []);
  const isMobileSmall = useMemo(() => window.innerWidth <= 504, []);
  const [showTable, setShowTable] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [hideTextContainer, setHideTextContainer] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [finish, setFinish] = useState(false);

  useEffect(() => {
    const handleAnimationSequence = async () => {
      if (!isOpen) {
        return;
      }

      if (isMobileSmall) {
        setShowOverlay(true);
        await delay(500); // Delay before showing overlay
      }

      setShowContent(true);
      await delay(2000); // Wait for content to be visible for a while

      setHideTextContainer(true);
      await delay(200); // Wait for fade-out animation to complete

      setShowTable(true);
      await delay(1000); // Wait for table slide-in animation to complete

      setFinish(true);
    };
    handleAnimationSequence();
  }, [isOpen, isMobileSmall]);

  if (!isOpen) return null;

  return (
    <div
      className="project-info-page"
      style={{
        width: `${
          document.body.classList.contains('menu-open') && !isMobile
            ? 'calc(100vw - 260px)'
            : '100vw'
        }`,
        height: `${isMobile ? 'calc(100dvh - 50px)' : '100dvh'}`,
      }}
    >
      {isMobileSmall && showOverlay && (
        <div className="project-info-page__overlay" />
      )}
      {showContent && (
        <div
          className="content-container"
          style={{
            backgroundImage: `url(${
              isMobileSmall ? BackgroundMobile : Background
            })`,
          }}
        >
          <div className={`inner-container`}>
            <div
              className={`logo-container ${
                finish
                  ? 'finish'
                  : showTable
                  ? 'scale-animation'
                  : 'show-animation'
              }`}
            >
              <img src={Logo} alt="Logo" />
            </div>
            {showTable ? (
              <div
                className={`table-container ${finish ? '' : 'show-animation'}`}
              >
                <InfoTable showTable={showTable} />
              </div>
            ) : (
              <div
                className={`text-container ${
                  hideTextContainer ? 'fade-out' : ''
                }`}
              >
                <img className="to-am" src={ToAmXanh} alt="To Am Xanh" />
                <img className="an-lanh" src={AnLanh} alt="An Lanh" />
                <img className="hanh-phuc" src={HanhPhuc} alt="Hanh Phuc" />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const projectInfoData = [
  {
    category: 'Tên dự án',
    value: 'JASARI',
    highlight: true,
  },
  {
    category: 'Vị trí',
    value: 'Phường 16, Quận 8 ( nay là Phường Phú Định), Tp.HCM',
  },
  {
    category: 'Chủ đầu tư',
    value: 'Công ty Cổ phần Đầu tư Năm Bảy Bảy',
  },
  {
    category: 'Quy mô dự án',
    value: '5,27 ha',
  },
  {
    category: 'Loại hình sản phẩm',
    value: 'Nhà chung cư hỗn hợp và nhà chung cư- nhà ở xã hội',
  },
  {
    category: 'Tổng số lượng sản phẩm',
    value: '2943 sản phẩm',
  },
  {
    category: 'Phân khu dự án',
    value:
      '5 phân khu nhà chung cư cao 33 tầng và 1 phân khu nhà chung cư-nhà ở xã hội cao 10 tầng',
  },
  {
    category: 'Thiết kế xấy dựng',
    value: 'Căn hộ 2PN + 1WC, Căn hộ 3PN + 2WC, Căn hộ Dual-key (3PN+ 2 WC)',
  },
  {
    category: 'Dân số dự kiến',
    value: '7.500 cư dân',
  },
  {
    category: 'Tổng giá trị đầu tư',
    value: '4.478 tỷ đồng',
  },
  {
    category: 'Thời gian hoàn thanh dự kiến',
    value: '2030',
  },
  {
    category: 'Giá bán',
    value: 'Đang cập nhật',
  },
];

export default ProjectInfoPage;

const InfoTable = ({ showTable }) => {
  return (
    <div
      className={`info-table ${showTable ? 'slide-in' : ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="info-table__header">
        <h2>THÔNG TIN TỔNG QUAN DỰ ÁN JASARI</h2>
      </div>
      <div className="info-table__content">
        {projectInfoData.map((item, index) => (
          <div
            key={index}
            className={`info-table__row ${
              item.highlight ? 'highlight-row' : ''
            }`}
          >
            <span className="info-table__category">{item.category}</span>
            <span
              className={`info-table__value ${
                item.highlight ? 'highlight-value' : ''
              }`}
              style={{
                paddingLeft: '20px',
              }}
            >
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
